/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { ListImportPreviewsQueryResponse } from '../types/ListImportPreviews'

function getListImportPreviewsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/importengine/previews/v2/` as const,
  }
  return res
}

/**
 * @summary List import previews for the current company
 * {@link /api/v1/importengine/previews/v2/}
 */
export async function listImportPreviews(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListImportPreviewsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListImportPreviewsUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
